import { render, staticRenderFns } from "./EditorActions.vue?vue&type=template&id=f240c5d4&"
import script from "./EditorActions.vue?vue&type=script&lang=js&"
export * from "./EditorActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports